import React from 'react'
import Header from './component/IndexPageEN/Header'
import ProductCstegoryAhan from './component/IndexPageEN/ProductCstegoryAhan'
import ProductCstegorySang from './component/IndexPageEN/ProductCstegorySang'
import SliderImageCompony from './component/IndexPageEN/SliderImageCompony'
import NewsCompony from './component/IndexPageEN/NewsCompony'
import AddressAndCommunication from './component/IndexPageEN/AddressAndCommunication'
import Footer from './component/IndexPageEN/Footer'
import AboutCompony from './component/IndexPageEN/AboutCompony'
import { Link } from 'react-router-dom'

function IndexEn() {
  return (
    <>
      <Header>
        <div className="logo-container">
          <img src="image/logo-banner-slider.png" alt="logo" className="logo" />
        </div>
        
        <div className="titleEN">
          Pahlavan Moghadam Trading Group
        </div>
        
        <div className="items">
          <Link className="item sang" to={"product?name=stone"} >
          <div className="item sang">
          <div className='shadoText-Sang'></div>
            {/* <img src="image/cat-1.jpg" alt="item1" className="item-image" /> */}
            <img src="image/Sang.jpg" alt="item1" className="item-image" />
              <div>
                <h3 className='titleMiddle-sang'> Stone  </h3>
                <div className='discription item-text-sang'>
                  <h3> Stone  </h3>
                  <p >  The stone group includes all kinds of natural stones for construction anbd decoration </p> 
                </div>
              </div>
          </div>
          </Link>
          <Link  className="item ahan" to={"product?name=iron"}>
            <div className="item ahan">
            <div className='shadoText-Ahan'></div>
              {/* <img src="image/cat-2.jpg" alt="item2" className="item-image" /> */}
              <img src="image/Ahan.jpg" alt="item2" className="item-image" />
              <div>
                <h3 className='titleMiddle-ahan'> Iron  </h3>
                <div className='discription item-text-ahan'>
                  <h3> Iron  </h3>
                  <p> The iron group includes metal products such as beams, rebars and angles for construction </p>
                </div>
              </div>
            </div>
          </Link>
        </div>  
      </Header>
      <ProductCstegoryAhan />
      <AboutCompony />
      <ProductCstegorySang />
      <SliderImageCompony />
      <NewsCompony />
      <AddressAndCommunication />
      <Footer />
    </>
  )
}

export default IndexEn
